import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { HttperrorhandlerService } from 'src/app/main/shared/http/httperrorhandler.service';
import { environment } from 'src/environments/environment';
import { isNullOrUndefined, isUndefined } from 'util';

@Injectable({
  providedIn: 'root'
})
export class DataService {

  API_URL = environment.url.APWRIMS_STAGING_API_URL; // Staging link
  STAGING_API_URL = environment.url.KALESHWARAM_API_URL;
  WRIS_API_URL = environment.url.KALESHWARAM_WRIS_API_URL;
  API = 'http://kaleshwaram.vassarlabs.com/api';
  APWRIMS_URL = 'http://apwrims.ap.gov.in/api';

  constructor(
    private http: HttpClient,
    private errorHandler: HttperrorhandlerService
  ) { }

  getWindData(url: string) {
    const dataPromise = new Promise((resolve) => {
      this.http.get(url).subscribe(
        data => {
          const obj = this.setWindData(data);
          resolve(obj);
        }
      );
    });
    return dataPromise;
  }

  getRainfallHeatMapData(url, options: object): Observable<any> {
    const heatMapUrl = url;
    return this.http.post<any>(environment.url.PLAY_URL + heatMapUrl, options).pipe(
      catchError(this.errorHandler.handleError('error in Heatmap data request', []))
    );
  }

  getSourceListForComponent(options): Observable<any> {
    return this.http.post<any>(environment.url.PLAY_URL + 'comm/getrankwisesource', options).pipe(
      catchError(this.errorHandler.handleError('All Sources data for Components : ', []))
    );
  }

  getDateRangeForComponent(component: string, source: string): Observable<any> {
    return this.http.get<any>(environment.url.PLAY_URL + 'comm/range2/' + component + '/' + source).pipe(
      catchError(this.errorHandler.handleError('Date range request for ' + component, []))
    );
  }

  getHeatMap(url: string) {
    const dataPromise = new Promise((resolve) => {
      this.http.get(url).subscribe(
        data => {
          const obj = this.setMapData(data);
          resolve(obj);
        });
    });
    return dataPromise;
  }

  setMapData(data: object) {
    const obj = {};
    let imageUrl = {};
    const imageBounds = [];
    for (const block of Object.keys(data)) {
      for (const { } of Object.keys(data[block])) {
        imageUrl = data[block]['heatMapImage'];
        let latlongs = [];
        latlongs.push(data[block]['heatMapImageBound']['southWest']['latitude']);
        latlongs.push(data[block]['heatMapImageBound']['southWest']['longitude']);
        imageBounds.push(latlongs);
        latlongs = [];
        latlongs.push(data[block]['heatMapImageBound']['northEast']['latitude']);
        latlongs.push(data[block]['heatMapImageBound']['northEast']['longitude']);
        imageBounds.push(latlongs);
      }
      obj['url'] = imageUrl;
      obj['bounds'] = imageBounds;
    }
    return obj;
  }

  getMaxMin2(arr) {
    let max = -10;
    let min = 10000000;
    for (let index = 0; index < arr.length; index++) {
      if (arr[index][1] && (min > arr[index][1])) {
        min = arr[index][1];
      }
      if (arr[index][1] && (max < arr[index][1])) {
        max = arr[index][1];
      }
    }
    return ([max, min]);
  }

  setWindData(data: object) {
    for (const block of Object.keys(data)) {
      const array = [];
      const obj1 = new Object();
      obj1['header'] = {
        parameterUnit: 'm.s-1',
        parameterNumber: 2,
        dx: 0.5,
        dy: 0.5,
        parameterNumberName: 'eastward_wind',
        la1: 40.0,
        la2: 5.0,
        parameterCategory: 2,
        lo2: 100.0,
        nx: 71,
        ny: 71,
        refTime: '2017-02-01 23:00:00',
        lo1: 65.0
      };
      obj1['data'] = data[block]['data1'];
      array[0] = obj1;

      const obj2 = {};
      obj2['header'] = {
        parameterUnit: 'm.s-1',
        parameterNumber: 3,
        dx: 0.5,
        dy: 0.5,
        parameterNumberName: 'eastward_wind',
        la1: 40.0,
        la2: 5.0,
        parameterCategory: 2,
        lo2: 100.0,
        nx: 71,
        ny: 71,
        refTime: '2017-02-01 23:00:00',
        lo1: 65.0
      };
      obj2['data'] = data[block]['data2'];
      array[1] = obj2;
      return array;
    }
  }

  // kaleshwaram api
  getMetaDataForAllPoints(): Observable<any> {
    return this.http.get<any>(this.API_URL + 'flowmanagement/masterdata/root/3a7a18ff-8614-4c90-aa98-451b333df3d9').pipe(
      catchError(this.errorHandler.handleError('Kpi data request', []))
    );
  }

  getStationRainfallData(options: object): Observable<any> {
    return this.http.post<any>(this.WRIS_API_URL + 'rf/aggregated', options).pipe(
      catchError(this.errorHandler.handleError('Kpi data request', []))
    );
  }

  getNewRainfallGisChart(postData) {
    return this.http.post<any>(this.WRIS_API_URL + 'rf/timeseries', postData).pipe(
      catchError(this.errorHandler.handleError('Kpi data request', []))
    );
  }

  getCurrForecastGraphData(postData) {
    if (!isNullOrUndefined(postData.ishecrasData)) {
      return this.http.get<any>(this.STAGING_API_URL + 'hecras/flowmanagement/pointdata/root/3a7a18ff-8614-4c90-aa98-451b333df3d9/' + postData.pointName + '/LASTKNOWN/' + postData.refTs + '/0/' + postData.hercastab);
    } else {
      const pointName = postData.pointName;
      const refTs = postData.refTs;
      const useActualVICR = postData.useActualVICR;
      const useForecastVICR = postData.useForecastVICR;
      const useGuageData = postData.useGuageData;
      return this.http.get<any>(this.STAGING_API_URL + 'flowmanagement/pointdata/root/3a7a18ff-8614-4c90-aa98-451b333df3d9/view/DAILY/' + pointName + '/' + refTs + '/' + useActualVICR + '/' + useForecastVICR + '/' + useGuageData);
    }
  }

  getCurrForecastGraphService(postData) {
    const pointName = postData.pointName;
    const refTs = postData.refTs;
    const useActualVICR = postData.useActualVICR;
    const useForecastVICR = postData.useForecastVICR;
    const useGuageData = postData.useGuageData;
    return this.http.get<any>(this.API_URL + 'flowmanagement/pointdata/root/3a7a18ff-8614-4c90-aa98-451b333df3d9/view/DAILY/' + pointName + '/' + refTs + '/' + useActualVICR + '/' + useForecastVICR + '/' + useGuageData).pipe(
      catchError(this.errorHandler.handleError('Kpi data request', []))
    );
  }


  getCurrForecastActualGraphData(postData) {
    if (postData.pType == 'RIVER_GAUGE') {
      return this.http.post<any>(this.WRIS_API_URL + 'rivergauge/timeseries', postData);
    }
    if (postData.pType == 'RESERVOIR') {
      return this.http.post<any>(this.WRIS_API_URL + 'reservoir/timeseries', postData);
    }
  }

  getCompareGraphService(postData) {
    if (!isNullOrUndefined(postData.ishecrasData)) {
      return this.http.get<any>(this.API_URL + 'hecras/flowmanagement/pointdata/root/3a7a18ff-8614-4c90-aa98-451b333df3d9/' + postData.pointName + '/LASTKNOWN/' + postData.refTs + '/0/' + postData.hercastab);
    } else {
      const pointName = postData.pointName;
      const refTs = postData.refTs;
      const accuracy = postData.accuracy;
      const useActualVICR = postData.useActualVICR;
      const useForecastVICR = postData.useForecastVICR;
      const useGuageData = postData.useGuageData;
      return this.http.get<any>(this.API_URL + 'flowmanagement/chart/comparison/root/3a7a18ff-8614-4c90-aa98-451b333df3d9/' + pointName + '/' + refTs + '/' + accuracy + '/' + useActualVICR + '/' + useForecastVICR + '/' + useGuageData).pipe(
        catchError(this.errorHandler.handleError('Kpi data request', []))
      );
    }
  }

  getHistoricalGraphService(postData) {
    if (!isNullOrUndefined(postData.ishecrasData)) {
      return this.http.get<any>(this.STAGING_API_URL + 'hecras/flowmanagement/pointdata/root/3a7a18ff-8614-4c90-aa98-451b333df3d9/' + postData.pointName + '/' + postData.startTs + '/' + postData.snapshotTs + '/0/' + postData.hercastab);
    } else {
      const pointName = postData.pointName;
      const snapshotTs = postData.snapshotTs;
      const startTs = postData.startTs;
      const useActualVICR = postData.useActualVICR;
      const useForecastVICR = postData.useForecastVICR;
      const useGuageData = postData.useGuageData;
      return this.http.get<any>(this.STAGING_API_URL + 'flowmanagement/pointdata/history/root/3a7a18ff-8614-4c90-aa98-451b333df3d9/' + pointName + '/' + startTs + '/' + snapshotTs + '/' + useActualVICR + '/' + useForecastVICR + '/' + useGuageData).pipe(
        catchError(this.errorHandler.handleError('Kpi data request', []))
      );
    }
  }

  getEnsembleGraphService(postData) {
    const pointName = postData.pointName;
    const endTs = postData.endTs;
    const startTs = postData.startTs;
    return this.http.get<any>(this.API_URL + 'flowmanagement/getEnsembleForecastData/' + pointName + '/' + startTs + '/' + endTs).pipe(
      catchError(this.errorHandler.handleError('Kpi data request', []))
    );
  }

  getObservedForecastRF(pointName, startdate, endDate) {
    const RF_URL = this.API_URL + 'flowmanagement/rainfall/data/3a7a18ff-8614-4c90-aa98-451b333df3d9/' + pointName + '/' + startdate + '/' + endDate + '/69';
    return this.http.get<any>(RF_URL);
  }

  formatEnsembleData(response) {
    const meanData: any[] = this.getEnsembleInflowValuesFromAPIResponse(response['-1']);
    const dependabilty75Data: any[] = this.getEnsembleInflowValuesFromAPIResponse(response['-3']);
    const dependabilty25Data: any[] = this.getEnsembleInflowValuesFromAPIResponse(response['-2']);
    const ensembleData = {};
    const timeStamps = [];
    for (const timeStamp in response['-1']) {
      if (!timeStamps.includes(timeStamp)) { timeStamps.push(timeStamp); }
    }
    timeStamps.sort();
    let fiveYearReturnValue;
    let twoYearReturnValue;
    let twentyYearReturnValue;
    let ymax;
    for (const timeStamp of timeStamps) {
      if (response['-4'] && response['-4'][timeStamp]) {
        twoYearReturnValue = response['-4'][timeStamp].in;
        break;
      }
    }
    for (const timeStamp of timeStamps) {
      if (response['-5'] && response['-5'][timeStamp]) {
        fiveYearReturnValue = response['-5'][timeStamp].in;
        break;
      }
    }
    for (const timeStamp of timeStamps) {
      if (response['-6'] && response['-6'][timeStamp]) {
        twentyYearReturnValue = response['-6'][timeStamp].in;
        break;
      }
    }
    ymax = fiveYearReturnValue;
    if (isUndefined(ymax)) {
      ymax = twoYearReturnValue;
    }
    meanData.sort((a, b) => a[0] - b[0]);
    dependabilty75Data.sort((a, b) => a[0] - b[0]);
    dependabilty25Data.sort((a, b) => a[0] - b[0]);
    for (const ensembleNo in response) {
      if (Number(ensembleNo) < 0) { continue; }
      const ensembleNoData = response[ensembleNo];
      for (const timeStamp in ensembleNoData) {
        if (!isNullOrUndefined(timeStamp)) {
          if (!ensembleData[timeStamp]) {
            ensembleData[timeStamp] = [];
          }
          ensembleData[timeStamp].push(Number(Number(ensembleNoData[timeStamp]['in']).toFixed(2)));
        }
      }
    }
    for (const timeStamp in ensembleData) {
      if (!isNullOrUndefined(timeStamp)) {
        ensembleData[timeStamp].sort((a, b) => a - b);
      }
    }
    const ensemblePercentileData = {};
    const medianData = [];
    for (const timeStamp of timeStamps) {
      if (isNullOrUndefined(ensembleData[timeStamp])) { continue; }
      const dateForTimeStamp = new Date(Number(timeStamp));
      dateForTimeStamp.setHours(0);
      dateForTimeStamp.setMinutes(0);
      dateForTimeStamp.setSeconds(0);
      dateForTimeStamp.setMilliseconds(0);
      const roundedTimeStamp = dateForTimeStamp.getTime();
      let median_index = this.calculatePercentile(ensembleData[timeStamp], 50);
      if (!ensembleData[timeStamp][median_index]) { continue; }
      const medianValue = Number(Number(ensembleData[timeStamp][median_index]).toFixed(2));
      medianData.push([Number(roundedTimeStamp), medianValue]);

      const ninetyPercentileIndex = this.calculatePercentile(ensembleData[timeStamp], 100);
      if (!isNullOrUndefined(ensembleData[timeStamp][ninetyPercentileIndex])) {
        const ninetyPercentilValue = ensembleData[timeStamp][ninetyPercentileIndex];
        if (isNullOrUndefined(ymax) || (ninetyPercentilValue > ymax)) {
          ymax = ninetyPercentilValue;
        }
      }

      for (let i = 0; i <= 100; i++) {
        const index = this.calculatePercentile(ensembleData[timeStamp], i);
        if (!ensemblePercentileData[i]) { ensemblePercentileData[i] = []; }
        ensemblePercentileData[i].push([Number(roundedTimeStamp), Number(Number(ensembleData[timeStamp][index]).toFixed(2)), medianValue]);
      }
    }
    for (let i = 0; i <= 100; i++) {
      if (isNullOrUndefined(ensemblePercentileData[i])) { continue; }
      ensemblePercentileData[i].sort((a, b) => (a[0] - b[0]));
    }
    medianData.sort((a, b) => (a[0] - b[0]));

    return [medianData, ensemblePercentileData, timeStamps, meanData, dependabilty25Data, dependabilty75Data, twoYearReturnValue, fiveYearReturnValue, twentyYearReturnValue, ymax];
  }

  calculatePercentile(arr: [], percentile): number {
    if (percentile === 0) {
      return 0;
    }
    const index = Number(((percentile * arr.length) / 100).toFixed(0));
    return index > 0 ? index - 1 : 0;
  }

  getEnsembleInflowValuesFromAPIResponse(data) {
    const returnData = [];
    for (const timeStamp in data) {
      if (!isNullOrUndefined(timeStamp)) {
        const dateForTimeStamp = new Date(Number(timeStamp));
        dateForTimeStamp.setHours(0);
        dateForTimeStamp.setMinutes(0);
        dateForTimeStamp.setSeconds(0);
        dateForTimeStamp.setMilliseconds(0);
        const roundedTimeStamp = dateForTimeStamp.getTime();
        returnData.push([Number(roundedTimeStamp), Number(Number(data[timeStamp]['in']).toFixed(2))]);
      }
    }
    return returnData;
  }

  getLatestKnownTableData(): Observable<any> {
    return this.http.get<any>(this.API_URL + 'flowmanagement/realtime/root/3a7a18ff-8614-4c90-aa98-451b333df3d9').pipe(
      catchError(this.errorHandler.handleError('Kpi data request', []))
    );
  }

  getReservoirMetaData(basin: string): Observable<any> {
    return this.http.get<any>(this.API_URL + 'basinflowmetadata/' + basin).pipe(
      catchError(this.errorHandler.handleError('Kpi data request', []))
    );
  }

  getBasinTableDataNew(interval: string): Observable<any> {
    return this.http.get<any>(this.API_URL + 'flowmanagement/data/root/3a7a18ff-8614-4c90-aa98-451b333df3d9/view/' + interval).pipe(
      catchError(this.errorHandler.handleError('Kpi data request', []))
    );
  }

  getSettingsInfo(pointName): Observable<any> {
    return this.http.get<any>(this.API_URL + 'flowmanagement/settinginfo/3a7a18ff-8614-4c90-aa98-451b333df3d9/' + pointName).pipe(
      catchError(this.errorHandler.handleError('Kpi data request', []))
    );
  }

  updateSettingTabData(pointName, isRealtime, isVIC): Observable<any> {
    return this.http.get<any>(this.API_URL + 'flowmanagement/updatesettingdata/3a7a18ff-8614-4c90-aa98-451b333df3d9/' + pointName + '/realtime/' + isRealtime + '/lateral/' + isVIC).pipe(
      catchError(this.errorHandler.handleError('Kpi data request', []))
    );
  }

  getDateandTimeDashSeparatorNew(timestamp) {
    const d = new Date(timestamp);
    const year = d.getFullYear().toString();
    let month: any = d.getMonth() + 1;
    month = month.toString();
    let date = d.getDate().toString();
    let hours = d.getHours().toString();
    let minutes = d.getMinutes().toString();
    let seconds = d.getSeconds().toString();
    if (month.length < 2) { month = '0' + month; }
    if (date.length < 2) { date = '0' + date; }
    if (hours.length < 2) { hours = '0' + hours; }
    if (minutes.length < 2) { minutes = '0' + minutes; }
    if (seconds.length < 2) { seconds = '0' + seconds; }
    const str = year + '-' + month + '-' + date + ' ' + hours + ':' + minutes + ':' + seconds;
    return str;
  }

  getNDayListInFormat(referenceTS, noOfDays, offset) {
    if (isNullOrUndefined(referenceTS)) {
      referenceTS = new Date().getTime();
    }
    const dayList = [];
    for (let i = offset; i < (noOfDays + offset); i++) {
      let day;
      const currDay = new Date(referenceTS + (i * 24 * 60 * 60 * 1000));
      const date = (currDay.getDate() > 9) ? currDay.getDate() : '0' + currDay.getDate();
      const month = ((currDay.getMonth() + 1) > 9) ? (currDay.getMonth() + 1) : '0' + (currDay.getMonth() + 1);
      const year = currDay.getFullYear();
      day = year.toString() + month.toString() + date.toString();
      dayList.push(day);
    }
    return dayList;
  }
}
